export default "__VITE_ASSET__Dm$moaf5__"